const baseUrl = process.env.BASE_URL || "/"
const normalizedBaseUrl = baseUrl.endsWith("/") ? baseUrl : `${baseUrl}/`

export const brandLogo = `${normalizedBaseUrl}branding/well-come-fit-logo.png?v=2026-08-12`
